import React from 'react';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import Form from '../../../form';
import { setJsonValue, _jsonValue } from '../../../../redux/issueSlice';
import { RootState } from '../../../../app/store';
import { SDCredentialValues } from '../../types/types';
import SDCredentialFormContent from './SDCredentialFormContent';
import { mapJsonEditorToFormValues } from './utils/mapJsonEditorToFormValues';
import SectionDivider from '../../../ui/SectionDivider';

const validationSchema = Yup.object().shape({
    contexts: Yup.array().of(Yup.string()),
    coreFields: Yup.array().of(Yup.object().shape({ key: Yup.string(), value: Yup.string() })),
    holder: Yup.string(),
    subjectType: Yup.string(),
    customAttributes: Yup.array().of(
        Yup.object().shape({ type: Yup.string(), name: Yup.string(), value: Yup.string() })
    ),
    subjectAttrs: Yup.array().of(Yup.object().shape({ key: Yup.string(), value: Yup.string() }))
});

export function buildCredentialJson(values: SDCredentialValues) {
    const coreFieldsObj: Record<string, string> = {};
    for (const { key, value } of values.coreFields) {
        coreFieldsObj[key] = value;
    }
    const subjectAttrsObj: Record<string, string> = {};
    for (const { key, value } of values.subjectAttrs) {
        subjectAttrsObj[key] = value;
    }
    return {
        '@context': values.contexts,
        ...coreFieldsObj,
        credentialSubject: {
            holder: values.holder,
            type: values.subjectType,
            customAttribute: values.customAttributes,
            ...subjectAttrsObj
        }
    };
}

export default function CredentialCreate({ onGenerate }: { onGenerate?: () => void }) {
    const dispatch = useDispatch();
    const rawJsonEditorValue = useSelector((state: RootState) => state.issue.jsonEditorValue);
    const savedJsonValue = useSelector(_jsonValue);
    const initialValues = React.useMemo(
        () => mapJsonEditorToFormValues(rawJsonEditorValue),
        [rawJsonEditorValue]
    );

    return (
        <Form
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={() => {}}>
            <SectionDivider />
            <SDCredentialFormContent
                onSubmit={(json) => dispatch(setJsonValue(json))}
                onGenerate={onGenerate}
                initialJson={savedJsonValue}
            />
        </Form>
    );
}
